import styled from 'styled-components';

export const ScLazyLoad = styled.div`
  &:empty {
    display: none;
  }
`;
